<template>
  <div class="connect" @click="modalType = 1">
    <img src="../assets/imgs/connect_us.png" alt="" />
  </div>
  <div class="modal_back" v-if="modalType"></div>
  <div class="report_modal" v-if="modalType > 2">
    <div class="close" @click="modalType = 0">
      <img src="../assets/imgs/close.png" alt="" />
    </div>
    <div class="title">填写邮箱地址下载报告</div>
    <div class="item">
      <input
        type="text"
        v-model="formData.email"
        placeholder="请输入您的邮箱地址"
        :class="{ err: errStatus === 2 }"
      />
      <div class="button" @click="ensure()">提交</div>
    </div>
  </div>
  <div class="modal" v-if="modalType === 1">
    <div class="close" @click="modalType = 0">
      <img src="../assets/imgs/close.png" alt="" />
    </div>
    <div class="title">联系我们，一起了解中国网购市场</div>
    <div class="sub_title">中国电商市场监测先锋，研究并追踪中国网购市场</div>
    <div class="content">
      <div class="form">
        <div class="item">
          <div class="lable">公司名称</div>
          <input
            type="text"
            v-model="formData.company"
            placeholder="请输入您所在的公司名称"
            :class="{ err: errStatus === 1 }"
          />
        </div>
        <div class="item">
          <div class="lable">邮箱地址</div>
          <input
            type="text"
            v-model="formData.email"
            placeholder="请输入邮箱地址"
            :class="{ err: errStatus === 2 }"
          />
        </div>
        <div class="item">
          <div class="lable">您的称呼</div>
          <input
            type="text"
            v-model="formData.name"
            placeholder="请输入您的称呼"
            :class="{ err: errStatus === 3 }"
          />
        </div>
        <div class="item">
          <div class="lable">手机号码</div>
          <input
            type="text"
            v-model="formData.mobile"
            placeholder="请输入您的联系方式"
            :class="{ err: errStatus === 4 }"
          />
        </div>
        <div class="item">
          <div class="lable">咨询的行业/品类</div>
          <input
            type="text"
            v-model="formData.industry"
            placeholder="咨询的行业或品类，用顿号隔开"
          />
        </div>
        <div class="item">
          <div class="lable"></div>
          <div class="button" @click="ensure()">确定</div>
        </div>
      </div>
      <div class="gzh">
        <img src="../assets/imgs/official_account.png" alt="" />
        <div class="des">关注思勃公众号</div>
      </div>
    </div>
  </div>
  <div class="success" v-if="modalType === 2">
    <div class="head">
      <span>提交成功</span>
      <div class="close" @click="modalType = 0">X</div>
    </div>
    <div class="content">感谢您的提交<br />我们将尽快和您取得联系</div>
  </div>
</template>

<script lang="ts">
import { onMounted, reactive, ref, watch } from "@vue/runtime-core";
import { downloadReport, connectUs } from "@/api/http";
export default {
  name: "connectUs",
  setup() {
    const modalType = ref<number>(0);
    const errStatus = ref<number>(0);
    const formData = reactive({
      company: "",
      email: "",
      name: "",
      mobile: "",
      industry: "",
    });
    const emailErr = () => {
      const myreg =
        /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/;
      return !myreg.test(formData.email);
    };
    const phoneErr = () => {
      const myreg = /^1(3|4|5|7|8)\d{9}$/;
      return !myreg.test(formData.mobile);
    };
    const ensure = () => {
      if (modalType.value > 1) {
        if (!formData.email || emailErr()) {
          errStatus.value = 2;
        } else {
          errStatus.value = 0;
        }
      } else if (!formData.company) {
        errStatus.value = 1;
      } else if (!formData.email || emailErr()) {
        errStatus.value = 2;
      } else if (!formData.name) {
        errStatus.value = 3;
      } else if (!formData.mobile || phoneErr()) {
        errStatus.value = 4;
      } else {
        errStatus.value = 0;
      }
      if (errStatus.value) {
        return;
      }
      if (modalType.value > 1) {
        const { industry, ...params } = formData;
        downloadReport({ ...params, no: modalType.value }).then((data) => {
          if (data.code === "0") {
            modalType.value = 2;
          }
        });
      } else {
        connectUs(formData).then((data) => {
          if (data.code === "0") {
            modalType.value = 2;
          }
        });
      }
    };

    watch(modalType, () => {
      formData.company = "";
      formData.name = "";
      formData.mobile = "";
      formData.industry = "";
      errStatus.value = 0;
    });
    onMounted(() => {
      document.addEventListener("show_modal", (ev: any) => {
        modalType.value = ev.detail;
      });
    });
    return {
      modalType,
      formData,
      errStatus,
      ensure,
    };
  },
};
</script>
<style scoped lang="less">
.connect {
  cursor: pointer;
  position: fixed;
  right: 40px;
  bottom: 200px;
  font-size: 0px;
  box-shadow: 0 0 10px 1px #e6ebed;
  border-radius: 8px;
  overflow: hidden;
  z-index: 3;
}
.modal_back {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  z-index: 3;
  background: rgba(0, 0, 0, 0.3);
}
.report_modal {
  position: fixed;
  left: 50vw;
  top: 50vh;
  transform: translate(-50%, -50%);
  z-index: 3;
  background: #22272b;
  border-radius: 18px;
  padding: 38px;
  .close {
    position: absolute;
    right: 12px;
    top: 12px;
    cursor: pointer;
    img {
      width: 24px;
    }
  }
  .title {
    font-size: 28px;
    color: #fff;
    font-weight: bold;
    border-bottom: 0.44px solid #616466;
    padding-bottom: 18px;
  }
  .item {
    margin-top: 28px;
    display: flex;
    align-items: center;
    input {
      border: none;
      padding: 12px 20px;
      font-size: 16px;
      border-radius: 5px;
      width: 280px;
      border: 1px solid #fff;
      margin-right: 14px;
      &.err {
        border-color: red;
      }
    }
    .button {
      padding: 13px 20px;
      text-align: center;
      width: 64px;
      border-radius: 5px;
      font-size: 16px;
      color: #fff;
      background: #3c81e6;
      cursor: pointer;
    }
  }
}
.success {
  position: fixed;
  left: 50vw;
  top: 50vh;
  transform: translate(-50%, -50%);
  z-index: 3;
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  .head {
    background: #3c81e6;
    line-height: 50px;
    color:#fff;
    font-size: 14px;
    padding: 0 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .close{
      font-size: 18px;
      transform:scaleX(1.3);
      cursor: pointer;
    }
  }
  .content{
    text-align: center;
    width:450px;
    line-height: 28px;
    padding: 70px 0;
  }
}
.modal {
  position: fixed;
  left: 50vw;
  top: 50vh;
  transform: translate(-50%, -50%);
  z-index: 3;
  background: #22272b;
  border-radius: 18px;
  padding: 44px 74px;
  .close {
    position: absolute;
    right: 24px;
    top: 24px;
    cursor: pointer;
    img {
      width: 30px;
    }
  }
  .title {
    font-size: 32px;
    color: #fff;
    font-weight: bold;
  }
  .sub_title {
    font-size: 16px;
    color: #bbb;
    margin-top: 12px;
  }
  .content {
    margin-top: 26px;
    display: flex;
    border-top: 2px solid #616466;
    padding-top: 26px;
    .form {
      .item {
        display: flex;
        margin-bottom: 20px;
        align-items: center;
        .lable {
          display: flex;
          justify-content: space-between;
          width: 66px;
          color: #bbb;
          margin-right: 20px;
        }
        input {
          border: none;
          padding: 12px 20px;
          font-size: 16px;
          border-radius: 5px;
          width: 262px;
          border: 1px solid #fff;
          &.err {
            border-color: red;
          }
        }
        .button {
          padding: 12px 20px;
          text-align: center;
          width: 262px;
          border-radius: 5px;
          font-size: 16px;
          color: #fff;
          background: #3c81e6;
          cursor: pointer;
        }
      }
    }
    .gzh {
      margin-left: 28px;
      img {
        width: 128px;
      }
      .des {
        color: #bbb;
        margin-top: 6px;
        width: 128px;
        text-align: center;
      }
    }
  }
}
</style>
